



























































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { mapGetters, mapState } from 'vuex';

import {
  CompletionStatus,
  ExperimentGetter,
  FeatureSwitches,
  MobileGetter,
  User,
} from 'frontend/types';
import { RelatedLearningPathInfo } from 'frontend/types/learningPathV2';
import { RawLocation } from 'vue-router';
import Button from 'frontend/components/Button.vue';
import ICPNudgeModal from './ICPNudgeModal.vue';

@Component({
  components: {
    Button,
    ICPNudgeModal,
  },
  computed: {
    ...mapState('globals', ['user']),
    ...mapState('isFirstCourse', ['didNotStartALesson']),
    ...mapGetters('globals', ['inExperiment', 'featureSwitches']),
    ...mapGetters('pageHeader', ['isMobile']),
    ...mapGetters('relatedLearningPathInfo', ['learningPath']),
  },
})
export default class LessonButton extends Vue {
  private readonly user!: User;
  private readonly isMobile!: MobileGetter;
  private readonly didNotStartALesson!: boolean;
  private readonly learningPath?: RelatedLearningPathInfo;
  private featureSwitches!: FeatureSwitches;
  private inExperiment!: ExperimentGetter;

  @Prop({ type: Object, required: true })
  private link!: RawLocation;
  @Prop({ type: Boolean, required: true })
  private isLocked!: boolean;
  @Prop({ type: String, required: true })
  private completionStatus!: CompletionStatus;
  @Prop({ type: Boolean, default: false })
  private isRecommended!: boolean;
  @Prop({ type: Boolean, default: false })
  private isPractice!: boolean;
  @Prop({ type: Number, default: 0 })
  private practiceLessons!: number;
  @Prop({ type: Boolean, default: false })
  private isHighlighted!: boolean;
  @Prop({ type: Boolean, default: false })
  private isLast!: boolean;
  @Prop({ type: Object, required: true })
  private trackingPayload!: { axId: string; axType: string; axExtra: any };
  @Prop({ type: String, required: true })
  private courseName!: string;
  private showIcpNudge: boolean = false;

  private get isIcpNudgeEnabled(): boolean {
    return (
      !!this.featureSwitches.enable_icp_nudge &&
      this.inExperiment('icp_nudge_08_23_v3', 'experiment')
    );
  }

  private get lessonButtonStateClass(): string {
    if (this.isLocked) {
      return 'locked';
    }
    if (this.isRecommended) {
      return 'recommended';
    }
    if (this.isHighlighted && this.completionStatus !== 'completed') {
      return 'highlighted';
    }

    return this.completionStatus;
  }

  private get isInLLPRolloutExperiment(): boolean {
    return !!this.learningPath;
  }

  private preventIfLocked(event: Event): void {
    if (!this.user.is_authenticated || this.isLocked) {
      event.preventDefault();
      this.$emit('access-prevented');
    }
  }

  private handleClick(event: Event): void {
    if (!this.isIcpNudgeEnabled) {
      this.preventIfLocked(event);

      return;
    }

    // If user is not logged in, fallback to default non-experiment behavior
    if (!this.user.is_authenticated) {
      event.preventDefault();
      this.$emit('access-prevented');
      return;
    }

    // The user is logged in and a free user, show them the ICP nudge
    if (this.isLocked) {
      event.preventDefault();
      this.showIcpNudge = true;
    }
  }
}
